import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    font-size: 14px;
    overflow: hidden;

    // Override breadcrumb styles to match the existing brand styling
    nav {
        width: 100%;
    }

    ol {
        margin: 0;
        padding: 0;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    // Ensure breadcrumb links have proper hover states
    a {
        text-decoration: none;
        color: #64748b;
        transition: color 0.2s ease;

        &:hover {
            color: #1e293b;
        }
    }

    // Current page styling
    span[role='link'] {
        color: #1e293b;
        font-weight: 500;
    }
`;
